export interface CatalogProduct {
  id: string;
  reference: string;
  line: string;
  widthCm: number;
  lengthCm: number;
  areaM2: number;
  price: number;
  warehouseStock: number;
  freeZoneStock: number;
  imageUrl?: string;
  brand?: string;
  adhesiveName?: string;
  adhesiveUnitsPerSheet?: number;
  adhesiveUnitPrice?: number;
  sealantName?: string;
  sealantCoverageM2PerQuart?: number;
  sealantQuartPrice?: number;
}

export interface CatalogAccessory {
  id: string;
  reference: string;
  category: string;
  stock: number;
  price: number;
  unit?: string;
  name?: string;
}

export const catalogProducts: CatalogProduct[] = [
  {
    id: "CONCRETO ENCOFRADO",
    reference: "CONCRETO ENCOFRADO",
    line: "Clay",
    widthCm: 290,
    lengthCm: 56,
    areaM2: 1.624,
    price: 315000,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 10,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/12/Textura-laminas-concreto-encofrado.webp",
    brand: "StoneFlex",
  },
  {
    id: "CUT STONE 120 X 60",
    reference: "CUT STONE 120 X 60",
    line: "Clay",
    widthCm: 120,
    lengthCm: 60,
    areaM2: 0.72,
    price: 123400,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 1,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 10,
    sealantQuartPrice: 46200,
    warehouseStock: 5,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/12/Cut-Stone-Textura.webp",
    brand: "StoneFlex",
  },
  {
    id: "TAPIA NEGRA",
    reference: "TAPIA NEGRA",
    line: "Clay",
    widthCm: 295,
    lengthCm: 120,
    areaM2: 3.54,
    price: 643680,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 5,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 10,
    sealantQuartPrice: 46200,
    warehouseStock: 5,
    freeZoneStock: 17,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/12/Textura-laminas-tapia.webp",
    brand: "StoneFlex",
  },
  {
    id: "CONCRETE WITH HOLES   1.22 X 0.61",
    reference: "CONCRETE WITH HOLES   1.22 X 0.61",
    line: "Concreto",
    widthCm: 120,
    lengthCm: 60,
    areaM2: 0.72,
    price: 165600,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.7,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 12,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-laminas-pagina-1.webp",
    brand: "StoneFlex",
  },
  {
    id: "CONCRETO BLANCO  1.22 X 0.61",
    reference: "CONCRETO BLANCO  1.22 X 0.61",
    line: "Concreto",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.7,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 796,
    freeZoneStock: 4362,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2024/09/Concreto-blanco-textura.png",
    brand: "StoneFlex",
  },
  {
    id: "CONCRETO BLANCO 2.44 X 1.22",
    reference: "CONCRETO BLANCO 2.44 X 1.22",
    line: "Concreto",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 576840,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 45,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2024/09/Concreto-blanco-textura.png",
    brand: "StoneFlex",
  },
  {
    id: "CONCRETO GRIS  1.22 X 0.61",
    reference: "CONCRETO GRIS  1.22 X 0.61",
    line: "Concreto",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.7,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 606,
    freeZoneStock: 910,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2024/07/Concreto-Gris.jpg",
    brand: "StoneFlex",
  },
  {
    id: "CONCRETO GRIS 2.44 X 1.22",
    reference: "CONCRETO GRIS 2.44 X 1.22",
    line: "Concreto",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 576840,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 40,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2024/07/Concreto-Gris.jpg",
    brand: "StoneFlex",
  },
  {
    id: "CONCRETO GRIS MEDIO 1.22 X 0.61",
    reference: "CONCRETO GRIS MEDIO 1.22 X 0.61",
    line: "Concreto",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.7,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Texturas-pagina.webp",
    brand: "StoneFlex",
  },
  {
    id: "CONCRETO MEDIO 2.44 X 1.22",
    reference: "CONCRETO MEDIO 2.44 X 1.22",
    line: "Concreto",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 576840,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Texturas-pagina.webp",
    brand: "StoneFlex",
  },
  {
    id: "BURNING FOREST  1.22 X 0.61",
    reference: "BURNING FOREST  1.22 X 0.61",
    line: "Cuarcita",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 634,
    freeZoneStock: 40,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/Textura-laminas-burning-forest-1.webp",
    brand: "StoneFlex",
  },
  {
    id: "BURNING FOREST 2.44 X 1.22",
    reference: "BURNING FOREST 2.44 X 1.22",
    line: "Cuarcita",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 550620,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/Textura-laminas-burning-forest-1.webp",
    brand: "StoneFlex",
  },
  {
    id: "COPPER  1.22 X 0.61",
    reference: "COPPER  1.22 X 0.61",
    line: "Cuarcita",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: -310,
    freeZoneStock: 17,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/Textura-copper.webp",
    brand: "StoneFlex",
  },
  {
    id: "COPPER 2.44 X 1.22",
    reference: "COPPER 2.44 X 1.22",
    line: "Cuarcita",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 550620,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/Textura-copper.webp",
    brand: "StoneFlex",
  },
  {
    id: "GOLDEN 1.22 X 0.61",
    reference: "GOLDEN 1.22 X 0.61",
    line: "Cuarcita",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/texturas-silver-shine-gold-2.webp",
    brand: "StoneFlex",
  },
  {
    id: "JEERA GREEN  1.22 X 0.61",
    reference: "JEERA GREEN  1.22 X 0.61",
    line: "Cuarcita",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 434,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/texturas-stoneflex-jera-green.webp",
    brand: "StoneFlex",
  },
  {
    id: "JEERA GREEN 2.44 X 1.22",
    reference: "JEERA GREEN 2.44 X 1.22",
    line: "Cuarcita",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 550620,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/texturas-stoneflex-jera-green.webp",
    brand: "StoneFlex",
  },
  {
    id: "STEEL GRAY  1.22 X 0.61",
    reference: "STEEL GRAY  1.22 X 0.61",
    line: "Cuarcita",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 504,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/texturas-steel-grey-stoneflex-vertical.webp",
    brand: "StoneFlex",
  },
  {
    id: "STEEL GREY 2.44 X 1.22",
    reference: "STEEL GREY 2.44 X 1.22",
    line: "Cuarcita",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 550620,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/texturas-steel-grey-stoneflex-vertical.webp",
    brand: "StoneFlex",
  },
  {
    id: "SILVER SHINE GOLD  1.22 X 0.61",
    reference: "SILVER SHINE GOLD  1.22 X 0.61",
    line: "Cuarcita",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 40,
    freeZoneStock: 190,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/texturas-silver-shine-gold-2.webp",
    brand: "StoneFlex",
  },
  {
    id: "SILVER SHINE GOLD 2.44 X 1.22",
    reference: "SILVER SHINE GOLD 2.44 X 1.22",
    line: "Cuarcita",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 550620,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/texturas-silver-shine-gold-2.webp",
    brand: "StoneFlex",
  },
  {
    id: "SILVER SHINE  1.22 X 0.61",
    reference: "SILVER SHINE  1.22 X 0.61",
    line: "Cuarcita",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 194,
    freeZoneStock: 300,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/texturas-stoneflex-silver-shine-vertical-2-1.webp",
    brand: "StoneFlex",
  },
  {
    id: "SILVER SHINE 2.44 X 1.22",
    reference: "SILVER SHINE 2.44 X 1.22",
    line: "Cuarcita",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 550620,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/texturas-stoneflex-silver-shine-vertical-2-1.webp",
    brand: "StoneFlex",
  },
  {
    id: "MADERA EBANO 0.15 X 2.44 MTS",
    reference: "MADERA EBANO 0.15 X 2.44 MTS",
    line: "Madera",
    widthCm: 244,
    lengthCm: 15,
    areaM2: 0.366,
    price: 81512,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.5,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE WOOD",
    sealantCoverageM2PerQuart: 10,
    sealantQuartPrice: 75000,
    warehouseStock: 508,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-madera-Ebano.webp",
    brand: "StoneFlex",
  },
  {
    id: "MADERA NOGAL 0.15 X 2.44 MTS",
    reference: "MADERA NOGAL 0.15 X 2.44 MTS",
    line: "Madera",
    widthCm: 244,
    lengthCm: 15,
    areaM2: 0.366,
    price: 81512,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.5,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE WOOD",
    sealantCoverageM2PerQuart: 10,
    sealantQuartPrice: 75000,
    warehouseStock: 143,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-madera-Nogal.webp",
    brand: "StoneFlex",
  },
  {
    id: "MADERA TEKA 0.15 X 2.44 MTS",
    reference: "MADERA TEKA 0.15 X 2.44 MTS",
    line: "Madera",
    widthCm: 244,
    lengthCm: 15,
    areaM2: 0.366,
    price: 81512,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.5,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE WOOD",
    sealantCoverageM2PerQuart: 10,
    sealantQuartPrice: 75000,
    warehouseStock: 205,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-madera-teka.webp",
    brand: "StoneFlex",
  },
  {
    id: "CARRARA  1.22 X 0.61",
    reference: "CARRARA  1.22 X 0.61",
    line: "Mármol",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 177042,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 843,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-carrar-3.webp",
    brand: "StoneFlex",
  },
  {
    id: "CARRARA 2.44 X 1.22",
    reference: "CARRARA 2.44 X 1.22",
    line: "Mármol",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 743581,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 58,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-carrar-3.webp",
    brand: "StoneFlex",
  },
  {
    id: "CRYSTAL WHITE  1.22 X 0.61",
    reference: "CRYSTAL WHITE  1.22 X 0.61",
    line: "Mármol",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 177042,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-laminas-crystal-white-2.webp",
    brand: "StoneFlex",
  },
  {
    id: "CRYSTAL WHITE 2.44 X 1.22",
    reference: "CRYSTAL WHITE 2.44 X 1.22",
    line: "Mármol",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 743581,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 1,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-laminas-crystal-white-2.webp",
    brand: "StoneFlex",
  },
  {
    id: "HIMALAYA GOLD 1.22X0.61 MTS",
    reference: "HIMALAYA GOLD 1.22X0.61 MTS",
    line: "Mármol",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 177042,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 1,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-laminas-himalaya-2.webp",
    brand: "StoneFlex",
  },
  {
    id: "HIMALAYA GOLD 2.44 X 1.22",
    reference: "HIMALAYA GOLD 2.44 X 1.22",
    line: "Mármol",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 743581,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3.5,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-laminas-himalaya-2.webp",
    brand: "StoneFlex",
  },
  {
    id: "MINT WHITE",
    reference: "MINT WHITE",
    line: "Mármol",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    brand: "StoneFlex",
  },
  {
    id: "CORTEN STEEL 2.44 X 1.22",
    reference: "CORTEN STEEL 2.44 X 1.22",
    line: "Metales",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 798100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-laminas-Corten-Steel.webp",
    brand: "StoneFlex",
  },
  {
    id: "CORTEN STELL - 2.44 X 0.61",
    reference: "CORTEN STELL - 2.44 X 0.61",
    line: "Metales",
    widthCm: 244,
    lengthCm: 61,
    areaM2: 1.488,
    price: 399050,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 1.5,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 5,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-laminas-Corten-Steel.webp",
    brand: "StoneFlex",
  },
  {
    id: "MURAL BLUE PATINA WITH COPPER  -   2.44 X 0.61",
    reference: "MURAL BLUE PATINA WITH COPPER  -   2.44 X 0.61",
    line: "Metales",
    widthCm: 244,
    lengthCm: 61,
    areaM2: 1.488,
    price: 399050,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 1.5,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 94,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/texturas-mural-blue.webp",
    brand: "StoneFlex",
  },
  {
    id: "MURAL WHITE WITH COPPER GOLD -   2.44 X 0.61",
    reference: "MURAL WHITE WITH COPPER GOLD -   2.44 X 0.61",
    line: "Metales",
    widthCm: 244,
    lengthCm: 61,
    areaM2: 1.488,
    price: 399050,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 1.5,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 23,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-mural-white-1.webp",
    brand: "StoneFlex",
  },
  {
    id: "GATE TURQUOISE PATINA  COPPER  -   2.44 X 0.61",
    reference: "GATE TURQUOISE PATINA  COPPER  -   2.44 X 0.61",
    line: "Metales",
    widthCm: 244,
    lengthCm: 61,
    areaM2: 1.488,
    price: 399050,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 1.5,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 108,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/textura-turquoise-1-1.webp",
    brand: "StoneFlex",
  },
  {
    id: "BLACK 1.22 X 0.61",
    reference: "BLACK 1.22 X 0.61",
    line: "Pizarra",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 138,
    freeZoneStock: -1035,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/05/texturas-stoneflex-black-vetical-2.avif",
    brand: "StoneFlex",
  },
  {
    id: "BLACK 2.44 X 1.22",
    reference: "BLACK 2.44 X 1.22",
    line: "Pizarra",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 550620,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 77,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/05/texturas-stoneflex-black-vetical-1.avif",
    brand: "StoneFlex",
  },
  {
    id: "INDIAN AUTUMN  1.22 X 0.61",
    reference: "INDIAN AUTUMN  1.22 X 0.61",
    line: "Pizarra",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 412,
    freeZoneStock: 540,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/06/texturas-stoneflex-indian-autumn-vetical.avif",
    brand: "StoneFlex",
  },
  {
    id: "INDIAN AUTUMN 2.44 X 1.22",
    reference: "INDIAN AUTUMN 2.44 X 1.22",
    line: "Pizarra",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 550620,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 15,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/06/texturas-stoneflex-indian-autumn-vetical.avif",
    brand: "StoneFlex",
  },
  {
    id: "KUND MULTY  1.22 X 0.61",
    reference: "KUND MULTY  1.22 X 0.61",
    line: "Pizarra",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 49,
    freeZoneStock: -500,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/Textura-laminas-kund-multi.avif",
    brand: "StoneFlex",
  },
  {
    id: "kUND MULTY 2.44 X 1.22",
    reference: "kUND MULTY 2.44 X 1.22",
    line: "Pizarra",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 550620,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/07/Textura-laminas-kund-multi-2.avif",
    brand: "StoneFlex",
  },
  {
    id: "TAN  1.22 X 0.61",
    reference: "TAN  1.22 X 0.61",
    line: "Pizarra",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 131100,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: -410,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/06/texturas-stoneflex-Tan-vetical-2.avif",
    brand: "StoneFlex",
  },
  {
    id: "TAN 2.44 X 1.22",
    reference: "TAN 2.44 X 1.22",
    line: "Pizarra",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 550620,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 76,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/06/texturas-stoneflex-Tan-vetical-2.avif",
    brand: "StoneFlex",
  },
  {
    id: "D.BLACK TRANSLUCIDO",
    reference: "D.BLACK TRANSLUCIDO",
    line: "Translucido",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 186990,
    adhesiveName: "ADHESIVO CRYTAL STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 47450,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    brand: "StoneFlex",
  },
  {
    id: "INDIAN AUTUMN TRANSLUCIDA 2.44 X 1.22",
    reference: "INDIAN AUTUMN TRANSLUCIDA 2.44 X 1.22",
    line: "Translucido",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 785358,
    adhesiveName: "ADHESIVO CRYTAL STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 47450,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 0,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-laminas-translucida.webp",
    brand: "StoneFlex",
  },
  {
    id: "INDIAN AUTUMN TRANSLUCIDO  1.22 X 0.61",
    reference: "INDIAN AUTUMN TRANSLUCIDO  1.22 X 0.61",
    line: "Translucido",
    widthCm: 122,
    lengthCm: 61,
    areaM2: 0.744,
    price: 186990,
    adhesiveName: "ADHESIVO CRYTAL STONEFLEX",
    adhesiveUnitsPerSheet: 0.66,
    adhesiveUnitPrice: 47450,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 215,
    freeZoneStock: 570,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/08/Textura-laminas-translucida.webp",
    brand: "StoneFlex",
  },
  {
    id: "TRAVERTINO",
    reference: "TRAVERTINO",
    line: "Travertino",
    widthCm: 120,
    lengthCm: 60,
    areaM2: 0.72,
    price: 126720,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 1,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 2,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/12/Textura-laminas.webp",
    brand: "StoneFlex",
  },
  {
    id: "3D ADHESIVO -   0,90 M2 - BLACK",
    reference: "3D ADHESIVO -   0,90 M2 - BLACK",
    line: "3D",
    widthCm: 60,
    lengthCm: 15,
    areaM2: 0.9,
    price: 207072,
    adhesiveUnitsPerSheet: 0,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 172,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2024/09/3D-Auto-adhesivo-black.png",
    brand: "StoneFlex",
  },
  {
    id: "3D ADHESIVO -   0,90 M2 - INDIAN RUSTIC",
    reference: "3D ADHESIVO -   0,90 M2 - INDIAN RUSTIC",
    line: "3D",
    widthCm: 60,
    lengthCm: 15,
    areaM2: 0.9,
    price: 207072,
    adhesiveUnitsPerSheet: 0,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 280,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2025/09/Textura-laminas-3d-indian-rustic.webp",
    brand: "StoneFlex",
  },
  {
    id: "3D ADHESIVO -   0,90 M2 - TAN",
    reference: "3D ADHESIVO -   0,90 M2 - TAN",
    line: "3D",
    widthCm: 60,
    lengthCm: 15,
    areaM2: 0.9,
    price: 207072,
    adhesiveUnitsPerSheet: 0,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    warehouseStock: 140,
    freeZoneStock: 0,
    imageUrl:
      "https://www.latinstorehouse.com/wp-content/uploads/2024/09/3D-Auto-adhesivo.png",
    brand: "StoneFlex",
  },
  {
    id: "ANTARTICA RIAN XL",
    reference: "ANTARTICA RIAN XL",
    line: "Mármol",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 743581,
    warehouseStock: 74,
    freeZoneStock: 0,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 3,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    brand: "StoneFlex",
  },
  {
    id: "TRAVERTINE VETEADO BEIGE XL",
    reference: "TRAVERTINE VETEADO BEIGE XL",
    line: "Travertino",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 685000,
    warehouseStock: 45,
    freeZoneStock: 0,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 4,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    brand: "StoneFlex",
  },
  {
    id: "TRAVERTINE ROMANO WHITE XL",
    reference: "TRAVERTINE ROMANO WHITE XL",
    line: "Travertino",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 685000,
    warehouseStock: 87,
    freeZoneStock: 0,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 4,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    brand: "StoneFlex",
  },
  {
    id: "TRAVERTINE PULIDO WHITE XL",
    reference: "TRAVERTINE PULIDO WHITE XL",
    line: "Travertino",
    widthCm: 244,
    lengthCm: 122,
    areaM2: 2.977,
    price: 635900,
    warehouseStock: 127,
    freeZoneStock: 0,
    adhesiveName: "ADHESIVO STONEFLEX",
    adhesiveUnitsPerSheet: 4,
    adhesiveUnitPrice: 32039,
    sealantName: "SELLANTE SEMIBRIGHT 1/4 GALON",
    sealantCoverageM2PerQuart: 18,
    sealantQuartPrice: 46200,
    brand: "StoneFlex",
  },];

export const catalogAccessories: CatalogAccessory[] = [
  {
    id: "adhesivo-stoneflex",
    reference: "ADHESIVO STONEFLEX",
    category: "Adhesivos",
    price: 28039,
    stock: 9999,
  },
  {
    id: "adhesivo-crytal-stoneflex",
    reference: "ADHESIVO CRYTAL STONEFLEX",
    category: "Adhesivos",
    price: 43450,
    stock: 9999,
  },
  {
    id: "sellante-semibrillante",
    reference: "SELLANTE SEMIBRIGHT 1/4 DE GALON",
    category: "Sellantes",
    price: 46200,
    stock: 9999,
  },
  {
    id: "sellante-wood",
    reference: "SELLANTE WOOD",
    category: "Sellantes",
    price: 75000,
    stock: 9999,
  },
];
